// extracted by mini-css-extract-plugin
export default {"container":"TimeSpanSection_container__U8pZY"};